import React, { ReactNode } from "react";
import * as Accordion from '@radix-ui/react-accordion';


interface AccordionContentProps {
    children: ReactNode;
    className?: string;
  }
  
export const AccordionContent = React.forwardRef<HTMLDivElement, AccordionContentProps>(
    ({ children, className, ...props }, forwardedRef) => (
      <Accordion.Content
        className='AccordionContent'
        {...props}
        ref={forwardedRef}
      >
        <div className="AccordionContentText">{children}</div>
      </Accordion.Content>
    )
  );
  
  